import type {ReactElement} from 'react';
import React from 'react';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {FileTypeOptions} from '@Components/download-panel/components/file-type-option/file-type-option.types';
import {DownloadPdfQualityOption} from '@Components/download-panel/components/download-pdf-quality-option/download-pdf-quality-option';
import {DownloadImageQualityOption} from '@Components/download-panel/components/download-image-quality-option/download-image-quality-option';
import {DownloadVideoQualityOption} from '@Components/download-panel/components/download-video-quality-option/download-video-quality-option';
import {DownloadGifQualityOption} from '@Components/download-panel/components/download-gif-quality-option/download-gif-quality-option';
import {isPremiumUser} from '@Utils/user.util';

export function DownloadQualityOption(): ReactElement | null {
  const {fileType} = useDownloadPanelData();

  if (fileType === FileTypeOptions.PDF) {
    return <DownloadPdfQualityOption />;
  }

  if (isPremiumUser()) {
    return null;
  }

  if (fileType === FileTypeOptions.PNG || fileType === FileTypeOptions.JPG) {
    return <DownloadImageQualityOption />;
  }

  if (fileType === FileTypeOptions.GIF) {
    return <DownloadGifQualityOption />;
  }

  if (fileType === FileTypeOptions.MP4) {
    return <DownloadVideoQualityOption />;
  }

  return null;
}
